<template>
  <div>
    <h2>Installation 安装</h2>
    <h3>npm 安装</h3>
    <vue-markdown v-highlight :source="npm"></vue-markdown>
    <h3>cnd 引入</h3>
    <vue-markdown v-highlight :source="cdn"></vue-markdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      npm: `
    npm i vue-form-layer -S
      `,
      cdn: `
    <script src="https://unpkg.com/vue-form-layer/dist/vue-form-layer.js"><\/script>
      `
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/installation.vue